import React from 'react';
import PageHeader from './PageHeader';

// Backwards-compatible alias: SectionHeader and PageHeader are the same
// gradient page header. New code should import PageHeader directly.
export default function SectionHeader(props) {
  return <PageHeader {...props} />;
}
